const generateTicket = (report) => {
	return `
Issue description...

*Scenario*
- Step 1

*Expected result*
...

*Actual result*
...

*Context*

URL: ${report.page.url}

App type: ${report.store.app.appType}
App state: ${report.store.app.appState}

Width: ${report.window.width}
Height: ${report.window.height}
    `;
};

export { generateTicket };
